/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./gameadv.vue?vue&type=template&id=0b285619&scoped=true"
import script from "./gameadv.vue?vue&type=script&lang=js"
export * from "./gameadv.vue?vue&type=script&lang=js"
import style0 from "./gameadv.vue?vue&type=style&index=0&id=0b285619&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b285619",
  null
  
)

export default component.exports